export default {
      id: "is-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#is",
      toString: function () {
        return this.url;
      }
    }